import { Modal } from 'antd'
import Countdown from './../CountDown'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ReactComponent as ExpiredWarningIcon } from './../../assets/icons/expired-warning.svg'
import { copyToClipboard } from './../../helper/common'
import { CopyOutlined } from '@ant-design/icons'
import LoadingPopup from './../LoadingPopup'
import './index.scss'
import PaymentService from '../../services/paymentService'
import { HOST } from '../../constants/url'
import { PARAM_IS_MINI_APP } from '../../constants/params'
import { useLocation } from 'react-router-dom'
import BaseButton from '../BasicComponent/BaseButton'
const ModalPaymentQR = ({ open, onClose, driver, onRefresh, method }) => {
  const [base64, setBase64] = useState(null)
  const { t: translation } = useTranslation()
  const { totalPay, formatedTotalPay, qr, expiredInMinutes, runTime } = driver

  const [paymentMethod, setPaymentMethod] = useState({})
  const [loading, setLoading] = useState(true)
  const [expiredText, setExpiredText] = useState('Mã QR hết hiệu lực sau')
  const location = useLocation()
  const searchparam = location.search
  const params = new URLSearchParams(searchparam)
  const isMiniApp = params.get(PARAM_IS_MINI_APP) === 'true' || sessionStorage.getItem(PARAM_IS_MINI_APP) === 'true'

  useEffect(() => {
    ;(async () => {
      try {
        setLoading(true)
        const data = await PaymentService.getPaymentQRMethod({})
        const dataConverted = Object.fromEntries(Object.values(data).map((item) => [item.paymentMethodId, item]))
        setPaymentMethod(dataConverted)
      } finally {
        setLoading(false)
      }
    })()
  }, [])

  const onRf = () => {
    setExpiredText('Mã QR hết hiệu lực sau')
    onRefresh()
  }

  const dataQR = (() => {
    if (loading || !method) return {}
    return method === 'momo' ? driver?.qr?.momoQR : driver?.qr?.bankQR
  })()
  const convertToBase64 = async (url) => {
    try {
      const response = await fetch(url)
      const blob = await response.blob() // Lấy blob từ response

      const reader = new FileReader()
      reader.onloadend = () => {
        setBase64(reader.result) // Set kết quả base64 vào state
      }
      reader.readAsDataURL(blob) // Đọc blob dưới dạng base64
    } catch (error) {}
  }
  const qrUrl = (() => {
    if (method === 'momo') {
      if (dataQR?.qrDataURL) {
        if (dataQR?.qrDataURL?.includes('base64')) {
          return dataQR?.qrDataURL
        } else {
          convertToBase64(`${HOST}/${dataQR?.qrDataURL}`)
          return ''
        }
      } else {
        return dataQR?.qrDataURL
      }
    }

    if (dataQR?.qrData?.includes('base64')) {
      return dataQR?.qrData
    }

    return `${HOST}/${dataQR?.qrData}`
  })()
  return (
    <>
      <Modal title="" open={open} centered footer={null} closable={false} className="modal-payment-qr text-center py-3" onClose={onClose}>
        {loading || !method ? (
          <LoadingPopup type="content" />
        ) : (
          <div className="d-flex flex-column gap-1">
            <div className="modal-payment-qr-header mb-3">
              <h5 className="font-weight-600">Thanh toán</h5>
              <span>Chuyển khoản hoặc quét mã QR để thanh toán qua tất cả Ví và Ngân hàng</span>
            </div>

            <div className="modal-payment-qr-content d-flex align-items-center flex-column px-3 py-3 bg-white">
              <div>
                {paymentMethod[method]?.paymentMethodImageUrl && (
                  <img src={paymentMethod[method]?.paymentMethodImageUrl} width={186} alt="paymentMethodImageUrl" />
                )}
              </div>
              <div className="w-100 d-flex flex-column gap-3 mt-4">
                <div className="d-flex align-items-start justify-content-between gap-1">
                  <span className="modal-payment-qr-content-title">Tên tài khoản</span>
                  <span className="word-break-all w-100" style={{ textAlign: 'left' }}>
                    <b>{paymentMethod[method]?.paymentMethodReceiverName}</b>
                  </span>
                </div>
                <div className="d-flex align-items-start justify-content-between gap-1">
                  <span className="modal-payment-qr-content-title">Số tài khoản</span>

                  <div className="d-flex align-items-start gap-2 w-100">
                    <span className="word-break-all" style={{ textAlign: 'left' }}>
                      <b>{paymentMethod[method]?.paymentMethodIdentityNumber}</b>
                    </span>
                    <CopyOutlined onClick={() => copyToClipboard(paymentMethod[method]?.paymentMethodIdentityNumber)} />
                  </div>
                </div>
                <div className="d-flex align-items-start justify-content-between gap-1">
                  <span className="modal-payment-qr-content-title">Số tiền</span>
                  <div className="d-flex align-items-start gap-2 w-100">
                    <span className="word-break-all text_primary" style={{ textAlign: 'left' }}>
                      <b>{formatedTotalPay}đ</b>
                    </span>
                    <CopyOutlined onClick={() => copyToClipboard(formatedTotalPay)} />
                  </div>
                </div>
                <div className="d-flex align-items-start justify-content-between gap-1">
                  <span className="modal-payment-qr-content-title">Nội dung</span>

                  <div className="d-flex align-items-start gap-2 w-100">
                    <div className="w-100" style={{ textAlign: 'left' }}>
                      <div className="word-break-all text_primary mobile-wrap" style={{ textAlign: 'left' }}>
                        <b>{dataQR?.paymentContent}</b>
                      </div>
                      <div className="text_warning">Vui lòng ghi đúng nội dung chuyển khoản</div>
                    </div>
                    <CopyOutlined onClick={() => copyToClipboard(dataQR?.paymentContent)} />
                  </div>
                </div>
              </div>

              <div className="hr"></div>

              <div className="modal-payment-qr-footer d-flex align-items-center gap-1 justify-content-center mb-2">
                <ExpiredWarningIcon />
                &nbsp;
                <span className="">{expiredText}</span>
                <span className={`modal-payment-qr-expired-in-countdown`}>
                  <Countdown
                    formater={(time) => {
                      const minutes = Math.floor(time / 60)
                      const seconds = time % 60
                      const formattedTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`

                      return formattedTime
                    }}
                    seconds={expiredInMinutes * 60}
                    event={() => {}}
                    onEnd={() => {
                      setExpiredText('Mã QR hết hiệu lực.')
                      return (
                        <span onClick={onRf} className="cursor-pointer font-weight-600" style={{ color: 'var(--brand-primary)' }}>
                          Làm mới
                        </span>
                      )
                    }}
                    key={runTime}
                  />
                </span>
              </div>
              <div className="modal-payment-qr-img">
                <img src={qrUrl || base64} alt="pr" width={186} height={186} />
              </div>
              {!isMiniApp && (
                <div className="mt-2">
                  <a download={'qrcode.png'} href={qrUrl || base64} target="_blank" rel="noreferrer" className="download-qr py-1 px-3 text_primary">
                    Tải ảnh QR
                  </a>
                </div>
              )}
            </div>

            <div className="mt-4">
              <BaseButton onClick={onClose}>Đóng</BaseButton>
            </div>
          </div>
        )}
      </Modal>
    </>
  )
}

export default ModalPaymentQR
